// Encapsulates https://github.com/tus/tus-js-client
// It turns out that just importing this library on the server side prevents
// NodeJS server from the graceful shutdown when requested. As we only need this
// on the client-side, let's just prevent its server-side import.

import { Upload } from 'tus-js-client';

import { Barrier } from '@dr.pogodin/react-utils';

type UCP = ConstructorParameters<typeof Upload>;

type TusUploadArgT = {
  data: UCP[0];
  onProgress?: (progress: number) => void;
  url: string;
};

export async function tusUpload({
  data,
  onProgress,
  url,
}: TusUploadArgT): Promise<void> {
  const result = new Barrier<void>();

  const upload = new Upload(data, {
    onError: (error) => {
      void result.reject(error);
    },
    onProgress: onProgress && ((bytesUploaded, bytesTotal) => {
      onProgress(bytesUploaded / bytesTotal);
    }),
    onSuccess: () => {
      void result.resolve();
    },
    uploadUrl: url,
  });

  upload.start();

  return result;
}
